import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyA4aHNCdYm8MUMFrI-48o3s0UhrFUYFv6M",
  authDomain: "preview-brott.firebaseapp.com",
  databaseURL: "https://preview-brott-default-rtdb.firebaseio.com",
  projectId: "preview-brott",
  storageBucket: "preview-brott.appspot.com",
  messagingSenderId: "190285827319",
  appId: "1:190285827319:web:3cd15f551b04f023ed97f2",
  measurementId: "G-GTWEYVMKCY"
};

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
